var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadGlasses({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.738 12.563a.746.746 0 00-.748.75.751.751 0 00.748.75h11.96a.747.747 0 00.747-.75.751.751 0 00-.748-.75H3.737z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.94 10.688a.751.751 0 00-.748-.75H3.364c-.892 0-1.748.356-2.379.989a3.38 3.38 0 000 4.773c.631.633 1.487.988 2.379.988h13.828a.747.747 0 00.747-.75.751.751 0 00-.747-.75H3.364c-.496 0-.971-.197-1.322-.549a1.878 1.878 0 010-2.652c.35-.351.826-.549 1.322-.549h13.828a.747.747 0 00.747-.75zM.747 5.813h.157a.373.373 0 01.36.273 3.75 3.75 0 001.553 2.117 3.727 3.727 0 004.86-.678 3.757 3.757 0 00.919-2.462.376.376 0 01.374-.375.373.373 0 01.373.375c0 .905.327 1.78.92 2.462a3.727 3.727 0 004.86.678 3.75 3.75 0 001.553-2.117.375.375 0 01.36-.273h.156a.746.746 0 00.747-.75.751.751 0 00-.747-.75h-.156a.373.373 0 01-.36-.272 3.737 3.737 0 00-1.136-1.807 3.716 3.716 0 00-5.626.87.374.374 0 01-.426.162 1.764 1.764 0 00-1.037 0 .373.373 0 01-.426-.162 3.71 3.71 0 00-5.625-.87 3.736 3.736 0 00-1.137 1.807.375.375 0 01-.36.272H.748a.746.746 0 00-.747.75.751.751 0 00.747.75zm12.334-3a2.237 2.237 0 012.072 1.39 2.257 2.257 0 01-.487 2.451 2.24 2.24 0 01-3.828-1.59c0-.597.237-1.17.657-1.592.42-.422.991-.659 1.586-.659zm-8.222 0a2.237 2.237 0 012.071 1.39 2.257 2.257 0 01-.486 2.451 2.24 2.24 0 01-3.828-1.59c0-.597.236-1.17.657-1.592.42-.422.99-.659 1.586-.659z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M0 0h17.939v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadGlasses);
export default __webpack_public_path__ + "static/media/read-glasses.c6afac5fb287f20d40832002a5ff7b1d.svg";
export { ForwardRef as ReactComponent };